module.exports = __webpack_public_path__ + "img/role-work-with-guides.53083a1f.png";